import { formatRut } from '@/utils';

import type {
  LC_ListEnrollmentReportItem,
  LC_ListEnrollmentReportOut,
  EnrollmentReport,
  EnrollmentReportPage,
} from '../types/enrollmentReport.types';


export function mapEnrollmentReport(item: LC_ListEnrollmentReportItem): EnrollmentReport {
  return {
    employeeId: item.employeeId,
    rut: formatRut(item.employeeTaxIdentificationNumber),
    fullName: item.fullName,
    deviceName: item.deviceName,
    hasPin: item.hasPin,
    hasFingerprint: item.hasFingerprint,
    hasPalm: item.hasPalm,
    hasFace: item.hasFace,
    hasPhoto: item.hasPhoto,
    zktecoCount: item.zktecoFingerprintCount,
    uareUCount: item.uareUFingerprintCount,
    hu20Count: item.hu20FingerprintCount,
  };
}

export function mapEnrollmentReportPage(out: LC_ListEnrollmentReportOut): EnrollmentReportPage {
  const pagination = out.pagination;
  return {
    items: (out.items ?? []).map(mapEnrollmentReport),
    pagination: {
      currentPage: pagination?.currentPage ?? 1,
      pageSize: pagination?.pageSize ?? 0,
      totalRecords: pagination?.totalRecords ?? 0,
      totalPages: pagination?.totalPages ?? 0,
      hasPreviousPage: pagination?.hasPreviousPage ?? false,
      hasNextPage: pagination?.hasNextPage ?? false,
    },
  };
}
